module.exports = __webpack_public_path__ + "img/Learn_English_2.878162b7.jpg";